import _slicedToArray from "/var/lib/jenkins/workspace/minasidor.nsva.se/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/minasidor.nsva.se/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/minasidor.nsva.se/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/minasidor.nsva.se/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/var/lib/jenkins/workspace/minasidor.nsva.se/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/workspace/minasidor.nsva.se/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["key"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import chroma from "chroma-js";
import { fromPairs, kebabCase, pickBy } from "lodash-es";
import yaml from "yaml";
function adjustLightness(value) {
  return 1 - Math.pow(1 - value, 0.66);
}
var DEFAULT_SCALE_MODE = "hcl";
function removeTransparency(color) {
  color = chroma(color);
  var alpha = color.alpha();
  if (alpha === 1) {
    return color;
  }
  return chroma.mix(color.alpha(1), "white", alpha, "rgb");
}
var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
  }
  _createClass(Parser, [{
    key: "stringify",
    value: function stringify(items) {
      var obj = {};
      items.forEach(function (_ref) {
        var key = _ref.key,
          item = _objectWithoutProperties(_ref, _excluded);
        if (!item.value && typeof item.shades !== "object") {
          return;
        }
        key = item.name || item.label;
        if (!key) {
          return;
        }
        if (item.label === key || item.label === "") {
          delete item.label;
        }
        if (item.name === key || item.name === "") {
          delete item.name;
        }
        if (Object.keys(item).filter(function (key) {
          return key !== "value";
        }).length === 0) {
          obj[key] = item.value;
          return;
        }
        obj[key] = _objectSpread({}, item);
      });
      var str = yaml.stringify(obj);
      return str.replace(/"(#[0-9a-fA-F]{3,8})"/g, "$1");
    }
  }, {
    key: "normalize",
    value: function normalize(items) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$autoShadeLevels = _ref2.autoShadeLevels,
        autoShadeLevels = _ref2$autoShadeLevels === void 0 ? [50, 100, 200, 300, 400, 500, 600, 700, 800, 900] : _ref2$autoShadeLevels,
        _ref2$autoShadeScaleM = _ref2.autoShadeScaleMode,
        autoShadeScaleMode = _ref2$autoShadeScaleM === void 0 ? DEFAULT_SCALE_MODE : _ref2$autoShadeScaleM;
      return items.map(function (item) {
        var _item = item,
          key = _item.key,
          value = _item.value,
          _item$shades = _item.shades,
          shades = _item$shades === void 0 ? true : _item$shades;
        var color = chroma.valid(value) && removeTransparency(chroma(value));
        if (color) {
          item.value = color.hex("rgb");
        }
        if (shades === false) {
          shades = {};
        } else {
          var scale;
          if (shades === true) {
            shades = pickBy(item, function (value, key) {
              return !isNaN(key);
            });
            item = pickBy(item, function (value, key) {
              return isNaN(key);
            });
          } else if (Array.isArray(shades)) {
            shades = fromPairs(shades.map(function (shade) {
              return [Math.round(1000 - adjustLightness(chroma(shade).get("hcl.l") / 100) * 1000), shade];
            }));
          } else if (typeof shades !== "object") {
            shades = {};
          }
          if (!Object.values(shades).length && color) {
            shades[Math.round(1000 - color.get("hcl.l") * 10)] = value;
            scale = chroma.scale(["white"].concat(_toConsumableArray(Object.values(shades).map(removeTransparency)), ["black"])).mode(autoShadeScaleMode).domain([0].concat(_toConsumableArray(Object.keys(shades).map(Number)), [1000]));
            shades = fromPairs([100, 200, 300, 400, 500, 600, 700, 800].map(function (level) {
              var shade = scale(level).set("hcl.c", color.get("hcl.c")).hex("rgb");
              return [Math.round(1000 - adjustLightness(chroma(shade).get("hcl.l") / 100) * 1000), shade];
            }));
          }
          if (Object.values(shades).length) {
            scale = chroma.scale(["white"].concat(_toConsumableArray(Object.values(shades)), ["black"])).mode(autoShadeScaleMode)
            // .correctLightness()
            .domain([0].concat(_toConsumableArray(Object.keys(shades).map(Number)), [1000]));
            shades = fromPairs(autoShadeLevels.map(function (level) {
              return [level, scale(level).hex("rgb")];
            }));
          }
        }
        return _objectSpread(_objectSpread({
          label: key,
          name: kebabCase(key)
        }, item), {}, {
          shades: shades
        });
      });
    }
  }, {
    key: "parse",
    value: function parse(items) {
      if (typeof items === "string") {
        // items = items.replace(/(?<!")#[0-9a-fA-F]{3,8}\b(?!")/g, '"$&"');
        items = items.replace(/(")?(#[0-9a-fA-F]{3,8})\b(")?/g, '"$2"');
        items = yaml.parse(items);
      }
      if (Array.isArray(items)) {
        items = items.map(function (item, index) {
          if (typeof item === "string") {
            item = {
              value: item
            };
          }
          item.key = item.name || item.label || String(index);
          return item;
        });
      } else {
        items = Object.entries(items || {}).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            item = _ref4[1];
          if (typeof item === "string") {
            item = {
              value: item
            };
          }
          return _objectSpread(_objectSpread({}, item), {}, {
            key: key
          });
        });
      }
      return items;
    }
  }]);
  return Parser;
}();
export { Parser as default };